
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-window-2-line',
      title: 'Fenêtres PVC',
      description: 'Réparation et entretien de fenêtres PVC. Remplacement de joints, vitrage et mécanismes.',
      color: 'bg-blue-500',
      link: '/reparation-fenetre-pvc-lyon',
    },
    {
      icon: 'ri-building-line',
      title: 'Fenêtres Aluminium',
      description: 'Spécialiste des fenêtres alu. Réparation de châssis, joints et systèmes d\'ouverture.',
      color: 'bg-blue-600',
      link: '/reparation-fenetre-alu-lyon',
    },
    {
      icon: 'ri-plant-line',
      title: 'Fenêtres Bois',
      description: 'Restauration et réparation de fenêtres en bois. Traitement, peinture et remplacement.',
      color: 'bg-blue-700',
      link: '/reparation-fenetre-bois-lyon',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Baies Vitrées',
      description: 'Réparation de baies vitrées coulissantes. Remplacement de rails et roulettes.',
      color: 'bg-blue-500',
      link: '/reparation-baie-vitree-lyon',
    },
    {
      icon: 'ri-tools-line',
      title: 'Quincaillerie',
      description: 'Remplacement de poignées, serrures, charnières et tous types de quincaillerie.',
      color: 'bg-blue-600',
      link: '/remplacement-quincaillerie-fenetre-lyon',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Sécurité',
      description: 'Installation de systèmes de sécurité renforcée pour vos fenêtres et portes-fenêtres.',
      color: 'bg-blue-700',
      link: '/blog/securite-fenetres-lyon',
    },
  ];

  return (
    <section id="services" className="bg-white py-12 sm:py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
            NOS SERVICES
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4 px-4">
            Expertise Complète en
            <br />
            Rénovation de Fenêtres
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto px-4">
            Solutions adaptées à tous vos besoins de menuiserie
          </p>
        </div>

        {/* Services Grid - OPTIMIZED FOR MOBILE */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer active:scale-95"
            >
              {/* Icon */}
              <div className={`w-14 h-14 sm:w-16 sm:h-16 rounded-full ${service.color} flex items-center justify-center mb-5 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-white text-xl sm:text-2xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                {service.description}
              </p>

              {/* Arrow */}
              <div className="flex items-center justify-end">
                <div className="w-8 h-8 rounded-full bg-teal-50 flex items-center justify-center group-hover:bg-teal-100 transition-colors">
                  <i className="ri-arrow-right-line text-teal-600 text-lg group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Additional Links */}
        <div className="mt-10 sm:mt-12 lg:mt-16 text-center px-4">
          <p className="text-gray-600 text-sm sm:text-base mb-6">
            Découvrez également nos articles sur <Link to="/blog/isolation-thermique-fenetres-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">l'isolation thermique</Link>, <Link to="/blog/fenetres-double-vitrage-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">le double vitrage</Link> et <Link to="/blog/aides-financieres-fenetres-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">les aides financières</Link> disponibles.
          </p>
        </div>
      </div>
    </section>
  );
}
